import React from "react"
import Link from "./Link"

const ContactUs = (props) => (
    <Link to={"mailto:" + props.email}>{props.email}</Link>
)

export default ContactUs